/** @jsx React.DOM */
'use strict';

var React = require('react'),
    update = require('react/lib/update'),
    ItemTypes = require('./ItemTypes'),
    Box = require('./Box'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=    require('react-dnd'),DragDropMixin=$__1.DragDropMixin;

var Container = React.createClass({displayName: 'Container',
  mixins: [DragDropMixin],

  propTypes: {
    hideSourceOnDrag: PropTypes.bool.isRequired
  },

  getInitialState:function() {
    return {
      boxes: {
        'a': { top: 20, left: 80, title: 'Drag me around' },
        'b': { top: 180, left: 20, title: 'Drag me too' },
      }
    };
  },

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.BOX, {
      dropTarget: {
        acceptDrop:function(item, e) {
          var left = Math.round(item.startLeft + (e.pageX - item.startPageX)),
              top = Math.round(item.startTop + (e.pageY - item.startPageY));

          this.moveBox(item.id, left, top);
        }
      }
    });
  },

  moveBox:function(id, left, top) {
    var stateUpdate = {
      boxes: {}
    };

    stateUpdate.boxes[id] = {
      $merge: {
        left: left,
        top: top
      }
    };

    this.setState(update(this.state, stateUpdate));
  },

  render:function() {
    return (
      React.createElement("div", React.__spread({},  this.dropTargetFor(ItemTypes.BOX), 
           {style: {
             width: 300,
             height: 300,
             border: '1px solid black',
             position: 'relative'
           }}), 

        Object.keys(this.state.boxes).map(function(key)  {
          var box = this.state.boxes[key];

          return (
            React.createElement(Box, {key: key, 
                 id: key, 
                 left: box.left, 
                 top: box.top, 
                 hideSourceOnDrag: this.props.hideSourceOnDrag}, 
              box.title
            )
          );
        }.bind(this))

      )
    );
  }
});

module.exports = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-naive/Container.js
 ** module id = 137
 ** module chunks = 0
 **/